import {getMethod, putMethod} from '~/api'

async function get(tourId, request) {
    return await getMethod(`/api/ownTourContracts/${tourId}/itineraryDay`, request)
}

async function put(tourId, request) {
    return await putMethod(`/api/ownTourContracts/${tourId}/itineraryDay`, request)
}

export {get, put}
